import React from "react";
import { Container, Accordion } from "react-bootstrap";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import "./FAQ.css";

const FAQ = () => {
  const faqData = [
    {
      id: "0",
      question: "Which countries do you offer job opportunities in?",
      answer:
        "We provide international job opportunities across multiple countries and industries. Available destinations depend on current vacancies, employer requirements, and candidate eligibility.",
    },
    {
      id: "1",
      question: "How do I know if I am eligible for a job?",
      answer:
        "Eligibility depends on factors such as your education, work experience, skills, age, language proficiency, and the specific requirements of the employer and destination country.",
    },
    {
      id: "2",
      question: "How does the overseas recruitment process work?",
      answer:
        "The process generally includes profile evaluation, job matching, interview preparation, employer selection, documentation, offer processing, visa assistance, and pre-departure guidance.",
    },
    {
      id: "3",
      question: "Do you help with visa and documentation?",
      answer:
        "Yes, our team provides guidance throughout the documentation and visa process. We help candidates understand the required paperwork and assist them with the necessary steps.",
    },
    {
      id: "4",
      question: "How can I prepare for an international job interview?",
      answer:
        "We help candidates prepare by providing interview guidance, discussing common questions, explaining employer expectations, and sharing tips to improve communication and professional presentation.",
    },
  ];

  return (
    <section className="FAQ">
      <Container>
        <CommonHeading title="Frequently Asked Questions" />

        <div className="faqs_content">
          <Accordion defaultActiveKey={null} className="faqs_accordion">
            {faqData.map((faq) => (
              <Accordion.Item
                eventKey={faq.id}
                key={faq.id}
                className="faqs_item"
              >
                <Accordion.Header>{faq.question}</Accordion.Header>

                <Accordion.Body>{faq.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
};

export default FAQ;
